import { logger } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';

export const logError = ({
    error,
    ...params
}: {
    error: Error;
    description: string;
    requestUrl?: string;
    requestPayload?: unknown;
}) => {
    const { userId, url } = getContext();

    logger.error(error, {
        userId,
        url,
        ...params,
    });
};
